<template>
  <el-container>
    <el-header>
      <navbar />
    </el-header>
    <el-container>
      <el-aside width="200px">
        <sidebar />
      </el-aside>
      <el-main>
        <transition name="fade-transform" mode="out-in">
          <keep-alive>
            <router-view :key="key" />
          </keep-alive>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Navbar from './Navbar'
import Sidebar from './Sidebar'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar
  },
  computed: {
    key () {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss">
  html {
    height: 100%;
    box-sizing: border-box;
  }
  body{
    height: 100%;
  }
  a,
  a:focus,
  a:hover {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
  }
  #app {
    height: 100%;
  }
  .el-container{
    height: 100%;
  }
  .el-header{
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
    background-color: #e9d184;
    padding-left: 0!important;
  }
  .el-aside{
    width: auto!important;
  }
  .el-main{
    padding: 0 !important;
  }
  .el-menu{
    background-color: #3D3D3D!important;
  }
  .el-menu-item{
    background-color: #3D3D3D!important;
  }
  // .el-menu-item i{
  //   color: #fff!important;
  // }
  // .el-menu-item span{
  //   color: #fff;
  // }
</style>
